<app-breadcrumb [master]="'Należności'" [parentName]="'Przelewy'" [name]="'Lista'"></app-breadcrumb>
<div class="receivables-bank-job-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-bank-job-list-filters">

    <!--    <app-dict-insurance-companies-->
    <!--      [multiple]="true" label="TU"-->
    <!--      class="receivables-import-list-filter"-->
    <!--      [(ngModel)]="initialFilters.in$insuranceCompany" name="in$insuranceCompany"-->
    <!--      (selectedInsuranceCompanies)="selectedInsuranceCompanies = $event"-->
    <!--    ></app-dict-insurance-companies>-->

    <!--    <app-dict-->
    <!--      [multiple]="true" label="Importer"-->
    <!--      class="receivables-import-list-filter"-->
    <!--      [dictType]="'receivables_importer_' + (selectedInsuranceCompanies.length > 0 ? selectedInsuranceCompanies[0].key : '')"-->
    <!--      [(ngModel)]="initialFilters.importer" name="importer"-->
    <!--    ></app-dict>-->

    <!--    <app-dict-->
    <!--      [multiple]="false" label="Firma"-->
    <!--      class="receivables-import-list-filter"-->
    <!--      dictType="company"-->
    <!--      [(ngModel)]="initialFilters.company" name="company"-->
    <!--    ></app-dict>-->

    <!--    <app-datepicker-->
    <!--      class="receivables-import-list-filter"-->
    <!--      label="Data importu od"-->
    <!--      placeholder="2000-01-01"-->
    <!--      [required]="false"-->
    <!--      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"-->
    <!--    ></app-datepicker>-->

    <!--    <app-datepicker-->
    <!--      class="receivables-import-list-filter"-->
    <!--      label="Data importu do"-->
    <!--      placeholder="2000-01-01"-->
    <!--      [required]="false"-->
    <!--      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"-->
    <!--    ></app-datepicker>-->

    <!--    <app-dict-users-->
    <!--      label="Użytkownik"-->
    <!--      class="receivables-import-list-filter"-->
    <!--      [(ngModel)]="initialFilters.createdBy" name="createdBy"-->
    <!--    ></app-dict-users>-->


    <!--    <app-dict-->
    <!--      [multiple]="true" label="Status"-->
    <!--      class="receivables-import-list-filter"-->
    <!--      dictType="import_status"-->
    <!--      [(ngModel)]="initialFilters.in$status" name="in$status"-->
    <!--    ></app-dict>-->
  </form>

  <!--  <div class="receivables-import-list-buttons">-->
  <!--    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()"> <mat-icon>download</mat-icon> Pobierz raport</button>-->
  <!--    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
  <!--    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
  <!--  </div>-->

  <table mat-table [dataSource]="jobs" [trackBy]="trackTask">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data  </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdBy.firstName }}  {{ element.createdBy.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalRows">
      <th mat-header-cell *matHeaderCellDef> Liczba przelewów </th>
      <td mat-cell *matCellDef="let element">
        {{element.totalRows}}
      </td>
    </ng-container>

    <ng-container matColumnDef="sum">
      <th mat-header-cell *matHeaderCellDef> Łączna kwota przelewów </th>
      <td mat-cell *matCellDef="let element">
        {{element.sum}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column"  *ngIf="element.status.key !== 'delete'">
          <button  fxFlex="100"  mat-icon-button [matMenuTriggerFor]="menu"  *ngIf="(userPermissions | async).receivables.delete" ><mat-icon>expand_more</mat-icon></button>
          <mat-menu #menu="matMenu" xPosition="before">
            <button *ngIf="(userPermissions | async).receivables.delete && element.name" [disabled]="!(userPermissions | async).receivables?.delete"  mat-menu-item (click)="downloadBankFile(element)">Pobierz plik</button>
            <button *ngIf="(userPermissions | async).receivables.admin_root"  [disabled]="!(userPermissions | async).receivables?.admin_root" mat-menu-item (click)="deleteFile(element)">Usuń</button>
          </mat-menu>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

